

/**
 * @name ProfileConnectionsController
 * @param {service} Collector Service for profile
 */
function ProfileConnectionsController(
  Collector
) {
  let vm = this;
  vm.refreshAssociations = refreshAssociations;

  /**
   * @name refreshAssociations
   * @description Function to get a list of associations for the collector
   */
  function refreshAssociations() {
    Collector.refreshProfile().then(function() {
      vm.allAssociations = Collector.profile.associations;
    });
  }

  // Get fresh assocaitions
  refreshAssociations();
}

angular
  .module('inkfinder')
  .controller('ProfileConnectionsController', ProfileConnectionsController);



// WEBPACK FOOTER //
// ./components/collector/connections/connections.controller.js